const localizeForm = (
  formObject,
  {
    SUBORGANIZATION_FORM_SUBORGANIZATIONKEY_LABEL,
    SUBORGANIZATION_FORM_SUBORGANIZATIONKEY_PLACEHOLDER,
    SUBORGANIZATION_FORM_SUBORGANIZATIONKEY_ERROR,
    SUBORGANIZATION_FORM_COUNTRY_LABEL,
    SUBORGANIZATION_FORM_COUNTRY_PLACEHOLDER,
    SUBORGANIZATION_FORM_COUNTRY_ERROR,
    SUBORGANIZATION_FORM_CITY_LABEL,
    SUBORGANIZATION_FORM_CITY_PLACEHOLDER,
    SUBORGANIZATION_FORM_CITY_ERROR,
    SUBORGANIZATION_FORM_DISTRICT_LABEL,
    SUBORGANIZATION_FORM_DISTRICT_PLACEHOLDER,
    SUBORGANIZATION_FORM_DISTRICT_ERROR,
    SUBORGANIZATION_FORM_ADDRESS_LABEL,
    SUBORGANIZATION_FORM_ADDRESS_PLACEHOLDER,
    SUBORGANIZATION_FORM_ADDRESS_ERROR,
    SUBORGANIZATION_FORM_PHONE_LABEL,
    SUBORGANIZATION_FORM_PHONE_PLACEHOLDER,
    SUBORGANIZATION_FORM_PHONE_ERROR,
    SUBORGANIZATION_FORM_EMAIL_LABEL,
    SUBORGANIZATION_FORM_EMAIL_PLACEHOLDER,
    SUBORGANIZATION_FORM_EMAIL_ERROR,
    SUBORGANIZATION_FORM_ORGANIZATION_LABEL,
    SUBORGANIZATION_FORM_ORGANIZATION_PLACEHOLDER,
    SUBORGANIZATION_FORM_ORGANIZATION_ERROR,
  }
) => {
  const updatedForm = {
    ...formObject,
    formField: {
      ...formObject.formField,
      subOrganizationKey: {
        ...formObject.formField.subOrganizationKey,
        label:
          SUBORGANIZATION_FORM_SUBORGANIZATIONKEY_LABEL ??
          formObject.formField.subOrganizationKey.label,
        placeholder:
          SUBORGANIZATION_FORM_SUBORGANIZATIONKEY_PLACEHOLDER ??
          formObject.formField.subOrganizationKey.placeholder,
        errorMsg:
          SUBORGANIZATION_FORM_SUBORGANIZATIONKEY_ERROR ??
          formObject.formField.subOrganizationKey.errorMsg,
      },
      country: {
        ...formObject.formField.country,
        label: SUBORGANIZATION_FORM_COUNTRY_LABEL ?? formObject.formField.country.label,
        placeholder:
          SUBORGANIZATION_FORM_COUNTRY_PLACEHOLDER ?? formObject.formField.country.placeholder,
        errorMsg: SUBORGANIZATION_FORM_COUNTRY_ERROR ?? formObject.formField.country.errorMsg,
      },
      city: {
        ...formObject.formField.city,
        label: SUBORGANIZATION_FORM_CITY_LABEL ?? formObject.formField.city.label,
        placeholder: SUBORGANIZATION_FORM_CITY_PLACEHOLDER ?? formObject.formField.city.placeholder,
        errorMsg: SUBORGANIZATION_FORM_CITY_ERROR ?? formObject.formField.city.errorMsg,
      },
      district: {
        ...formObject.formField.district,
        label: SUBORGANIZATION_FORM_DISTRICT_LABEL ?? formObject.formField.district.label,
        placeholder:
          SUBORGANIZATION_FORM_DISTRICT_PLACEHOLDER ?? formObject.formField.district.placeholder,
        errorMsg: SUBORGANIZATION_FORM_DISTRICT_ERROR ?? formObject.formField.district.errorMsg,
      },
      address: {
        ...formObject.formField.address,
        label: SUBORGANIZATION_FORM_ADDRESS_LABEL ?? formObject.formField.address.label,
        placeholder:
          SUBORGANIZATION_FORM_ADDRESS_PLACEHOLDER ?? formObject.formField.address.placeholder,
        errorMsg: SUBORGANIZATION_FORM_ADDRESS_ERROR ?? formObject.formField.address.errorMsg,
      },
      phone: {
        ...formObject.formField.phone,
        label: SUBORGANIZATION_FORM_PHONE_LABEL ?? formObject.formField.phone.label,
        placeholder:
          SUBORGANIZATION_FORM_PHONE_PLACEHOLDER ?? formObject.formField.phone.placeholder,
        errorMsg: SUBORGANIZATION_FORM_PHONE_ERROR ?? formObject.formField.phone.errorMsg,
      },
      email: {
        ...formObject.formField.email,
        label: SUBORGANIZATION_FORM_EMAIL_LABEL ?? formObject.formField.email.label,
        placeholder:
          SUBORGANIZATION_FORM_EMAIL_PLACEHOLDER ?? formObject.formField.email.placeholder,
        errorMsg: SUBORGANIZATION_FORM_EMAIL_ERROR ?? formObject.formField.email.errorMsg,
      },
      organization: {
        ...formObject.formField.organization,
        label: SUBORGANIZATION_FORM_ORGANIZATION_LABEL ?? formObject.formField.organization.label,
        placeholder:
          SUBORGANIZATION_FORM_ORGANIZATION_PLACEHOLDER ??
          formObject.formField.organization.placeholder,
        errorMsg:
          SUBORGANIZATION_FORM_ORGANIZATION_ERROR ?? formObject.formField.organization.errorMsg,
      },
    },
  };
  return updatedForm;
};

export default localizeForm;
